<template>
  <div id="header" class="row d-flex align-items-center">
    <div :class="$store.state.customerInfo ? 'col-lg-5 col-md-12' : 'col-lg-8 col-md-12'">
      <a href="https://www.rychlydrat.cz/">
        <img src="/static/rd-images/logo.png" alt="Rychlý drát" id="logo" height="90"/>
      </a>
    </div>
    <div class="col col-lg-1 col-md-12 item item-1 text-lg-right">
      <nobr>
        <i class="fa-solid fa-at" aria-hidden="true"></i>
        <a href="http://www.rychlydrat.cz/kontakt" title="" target="_blank">Napište nám</a>
      </nobr>
    </div>
    <div class="col col-lg-3 col-md-12 item item-2 text-lg-right">
      <nobr>
        <i class="fa-solid fa-headset" aria-hidden="true"></i>
        <a href="tel:+420212244400">+420&nbsp;212&nbsp;244&nbsp;400</a>
      </nobr>
    </div>
    <div id="customer-info" class="col-lg-3 col-md-12 item item-3 d-flex" v-if="$store.state.customerInfo">
      <i class="fa-solid fa-user" aria-hidden="true"></i>
      &nbsp;
      <span>
        <div>{{ human_readable_name($store.state.customerInfo) }}</div>
        <div>{{ human_readable_address($store.state.customerInfo) }}</div>
        <div>
          <abbr title="variabilní symbol pro platby">VS</abbr> {{ $store.state.customerInfo.id }}
          <br/>
          <router-link to="/logout" title="">odhlásit</router-link>
        </div>
      </span>
    </div>
	</div>
</template>

<script>
export default {
  name: 'rd-samoobsluha-header',
  methods: {
    human_readable_name: function (ci) {
      return ci.name + ' ' + ci.lastname + ' ' + (ci.bussinesname ? ci.bussinesname : '')
    },
    human_readable_address: function (ci) {
      let address = ci.a1_ulice ? ci.a1_ulice : ci.a1_obec
      address += ' ' + ci.a1_cislo
      address += ', ' + ci.a1_obec
      return address
    }
  }
}
</script>
<style scoped>
a {
  color: black;
}
a:hover {
  color: #EB8108;
  text-decoration: none;
}

#header {
  margin-top: 2px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
  overflow: hidden;
  max-width: 1259px;
}
#logo {
  border: none;
}
#header .item {
  padding: 0.25em 0.5em;
}
#customer-info {
  align-items: center;
}
.item-1 {
  text-transform: uppercase;
}
i.fa-solid {
  color: #EB8108;
}
</style>



// WEBPACK FOOTER //
// Header.vue?c9196af8